import { Theme, Typography } from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'
import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined'
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined'

import { memo } from 'react'

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    docsNeededCls: {
      display: 'flex',
      flexDirection: 'column',
      borderRight: `1px solid ${theme.palette.grey[300]}`,
      justifyContent: 'center',
      height: '100%',
      paddingLeft: 30,
      [theme.breakpoints.down('md')]: {
        borderRight: 'none',
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
        margin: '10px 20px',
        paddingLeft: 10,
      },
    },
    headerText: {
      fontWeight: '700',
      fontSize: 18,
      marginTop: 10,
      [theme.breakpoints.down('md')]: {
        marginTop: 40,
      },
    },
    docsRequiredTextContainerCls: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 10,
    },
    microTextCls: {
      fontSize: 12,
      marginTop: 10,
      color: theme.palette.grey[600],
      [theme.breakpoints.down('md')]: {
        marginBottom: 10,
      },
    },
    iconCls: {
      color: theme.palette.grey[700],
      fontSize: 24,
    },
  }),
)

const DocsNeeded = () => {
  const {
    docsNeededCls,
    headerText,
    docsRequiredTextContainerCls,
    microTextCls,
    iconCls,
  } = useStyles()

  return (
    <div className={docsNeededCls}>
      <Typography className={headerText}>Sie benötigen</Typography>
      <span className={docsRequiredTextContainerCls}>
        <EuroOutlinedIcon className={iconCls} />
        <Typography sx={{ marginLeft: '10px' }}>Gehaltsnachweis</Typography>
      </span>
      <span className={docsRequiredTextContainerCls}>
        <AccountBalanceOutlinedIcon className={iconCls} />
        <Typography sx={{ marginLeft: '10px' }}>Kontoauszüge</Typography>
      </span>
      <Typography className={microTextCls}>
        Welche Nachweise erforderlich sind, hängt von Ihrem persönlichen Profil
        ab. Sie werden beim Abschluss des Kreditantrags danach gefragt.
      </Typography>
    </div>
  )
}

export default memo(DocsNeeded)
